import { Button } from "../../components/ui/Button";

function HowSolicitationConsignadoINSS({ openPersonalDataModal, onGoToRegister }) {
    return (
        <section id="HowSolicitationConsignadoINSS" className="bg-[#EAEAEA] py-16 px-6 mx-auto">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-between gap-12">

                <div className="w-full lg:w-1/2">
                    <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                        Solicitação 100% online
                    </span>

                    <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 leading-relaxed mb-4">
                        Descubra em passos simples como obter seu Empréstimo Consignado
                    </h2>

                    <h3 className="text-base font-bold text-gray-800 mb-4">
                        É rápido, fácil e sem burocracia:
                    </h3>

                    <ul className="space-y-6 mb-8">
                        <li className="flex items-center gap-4">
                            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">1</div>
                            <div className="flex flex-col">
                                <span className="text-[#37404E] font-bold">Preencha seus dados</span>
                                <span className="text-[#37404E]">Cadastre-se de forma simples e segura.</span>
                            </div>
                        </li>
                        <li className="flex items-center gap-4">
                            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">2</div>
                            <div className="flex flex-col">
                                <span className="text-[#37404E] font-bold">Veja sua oferta personalizada</span>
                                <span className="text-[#37404E]">Mostramos as melhores condições disponíveis para você.</span>
                            </div>
                        </li>
                        <li className="flex items-center gap-4">
                            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">3</div>
                            <div className="flex flex-col">
                                <span className="text-[#37404E] font-bold">Assine sem sair de casa</span>
                                <span className="text-[#37404E]">Tudo é feito online, com segurança e agilidade.</span>
                            </div>
                        </li>
                        <li className="flex items-center gap-4">
                            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">4</div>
                            <div className="flex flex-col">
                                <span className="text-[#37404E] font-bold">Receba o valor na conta</span>
                                <span className="text-[#37404E]">Dinheiro liberado rapidamente, direto no seu banco.</span>
                            </div>
                        </li>
                    </ul>


                    <Button onClick={onGoToRegister}>
                        Contratar agora
                    </Button>
                    <br />
                    <p className="text-xs text-gray-600 mt-5">
                        O prazo para pagamento é de até 96 parcelas mensais. Os valores abaixo são uma simulação e podem variar conforme as condições no momento da contratação.
                        Exemplo de contratação com convênio INSS: valor emprestado de R$6.000,00 com taxa de 1,85% ao mês (24,60% ao ano), parcelado em 86 vezes. Valor total pago: R$13.072,00 (valor financiado + encargos e taxa), em 86x de R$152,00.
                        Custo Efetivo Total (CET): 1,95% ao mês e 26,45% ao ano.
                        Se houver carência para início do pagamento, durante esse período haverá incidência de juros, que serão diluídos nas parcelas futuras.
                        Os valores de parcelas, limites de contratação, prazos, taxas de juros, tarifas e CET podem variar conforme o convênio e estão sujeitos a alterações sem aviso prévio.
                    </p>
                </div>

                <div className="w-full lg:w-1/2 flex justify-center items-center">
                    <img src="/assets/how-solicitation-consignado.png" alt="" />
                </div>
            </div>
        </section>
    );
}

export default HowSolicitationConsignadoINSS;